export class DominiosService {

  /*
  * Nombre tarjte Stickers
  */

  public static VALOR_TARJETA = 'TARJETA';
  public static VALOR_STICKER = 'STICKER';
  public static DOMINIO_TIPO_VISITANTE = 'FUNC';
  public static PARAMETRO_URL_FTP = 'URL_FTP';
  public static PARAMETRO_TIEMPO_SESSION_ACCESIBILIDAD = 'TIEMPO_ACCESIBILIDAD';
  public static SEDE_POR_DEFECTO = 'SEDE_DEFECTO';
  public static LLAVE_CAPTCHA = 'SITE_KEY';
  public static AGENDA_FECHA_ACTUAL = 'AGACTUAL';
  public static AGENDA_FECHA_SELECCIONADA = 'AGSELEC';
  public static AGENDA_FECHA_DISPONIBLE = 'AGDISP';
  public static MAXIMO_DIAS_AGENDA = 'AGRANGO';

  public static DOMINIO_SEDE = 'Sede';
  public static DOMINIO_GENERO = 'Genero';
  public static DOMINIO_TIPO_DISCAPACIDAD = 'TipoDiscapacidad';
  public static DOMINIO_MOTIVO_PRIORIDAD = 'MotivoPrioridad';
  public static DOMINIO_TIPO_IDENTIFICACION = 'TipoIdentificacion';
  public static DOMINIO_TIPO_VINCULACION = 'TipoVinculacion';
  public static DOMINIO_ESTADO_FUNCIONARIO = 'Estado';
  public static DOMINIO_TIPO_FUNCIONARIO = 'TipoFuncionario';
  public static DOMINIO_CARGO_FUNCIONARIO = 'CargoFuncionario';
  public static DOMINIO_TIPO_VEHICULO = 'TipoVehiculo';

  public static ESTADO_AGENDA_AGENDADA = 'AGENDADA';
  public static ESTADO_AGENDA_CANCELADA = 'CANCELADA';
  public static ESTADO_AGENDA_ACT_CON = 'ACT_CON';
  public static ESTADO_AGENDA_ACT_SIN = 'ACT_SIN';
  public static ESTADO_AGENDA_SALIDA_PARCIAL = 'SAL_PAR';

  public static ESTADO_ACTIVO_FIJO_VALOR_RETIRADO = 'RETIRADO';
  public static ESTADO_ACTIVO_FIJO_VALOR_INGRESADO = 'INGRESADO';
  public static ESTADO_ACTIVO_FIJO_INGRESADO = 'ING';
  public static ESTADO_ACTIVO_FIJO_RETIRADO = 'RET';
  public static VALOR_DOMINIO_INGRESADO = 'Ingresado';

  public static ESTADO_CODIGO_DISPONIBLE = 'DIS';
  public static ESTADO_CODIGO_EXTRAVIADO = 'EXT';
  public static ESTADO_CODIGO_EN_USO = 'USO';
  public static ESTADO_CODIGO_INACTIVO = 'INA';

  // CONSTANTES PROPIEDAD ACTIVO

  public static ACTIVO_MEN = 'MEN';
  public static ACTIVO_PROPIO = 'PROPIO';
  public static ACTIVO_MEN_SIN_REGISTRO = 'MEN_SIN_REGISTRO';
  // ROLES ACVIS
  public static ROL_VIGILANTE = 'VIG';
  public static ROL_PREAUTORIZADOR = 'PREAU';
  public static ROL_ADMINISTADOR = 'ADM';
  public static ROL_VENTANILLA = 'VEN';
  public static ROL_POI = 'POI';
  public static ROL_ADMINISTADOR_UAC = 'ADMUAC';

  public static ROL_ADMINISTRADOR_TH = 'ADMTH';
  public static ROL_ADMINISTRADOR_SGA = 'ADMSGA';
  public static ROL_ADMINISTRADOR_TEC = 'ADMTEC';
  public static ROL_FUNCIONARIO = 'FUNC';

  // Tipo de activo fijo del men de un funcionario
  public static ACTIVO_FIJO_AUTORIZADO = 'AUTORIZADO';
  public static ACTIVO_FIJO_ASIGNADO = 'ASIGNADO';

  public static TIPO_DOCUMENTO_PASAPORTE = 'PASAPORTE';
  public static TIPO_DOCUMENTO_EXTRANJERIA = 'CE';

  public static MOTIVO_PRIORIDAD_DISCAPACIDAD = 'M_DISCAPA';

  public static TIPO_DISCAPACIDAD_MOTORA = 'MOTORA';

  // Restricciones cargue documento
  public static TAMANIO_DOCUMENTO_ARL = 'TAMDARL';
  public static TAMANIO_ARCHIVO_FOTO = 'TAMFOTO';
  public static MENSAJE_CARACTERISTICA_FOTO = 'MSJRFOTO';
  public static MENSAJE_CARACTERISTICA_ARL = 'MSJRARL';

  // Incentivo bicicletas
  public static TIPO_FUNCIONARIO_PLANTA = 'PLANTA';

  public static ESTADO_FUNCIONARIO = 'ACT';
  // Dominio para estados de planes de compensación
  public static ESTADO_PLAN_COMPENSACION_ACTIVO = 'ACT';
  public static ESTADO_PLAN_COMPENSACION_INACTIVO = 'INA';

  // Dominio para estados de inscripciones a planes de compensación
  public static ESTADO_INSCRIPCION_PLAN_COMPENSACION_PENDIENTE = 'PENDIENTE';
  public static ESTADO_INSCRIPCION_PLAN_COMPENSACION_APROBADO = 'APROBADO';
  public static ESTADO_INSCRIPCION_PLAN_COMPENSACION_DEVUELTO = 'DEVUELTO';
  public static ESTADO_INSCRIPCION_PLAN_COMPENSACION_RECHAZADO = 'RECHAZADO';

  // Dominio para estados de solicitudes de ajustes a planes de compensación
  public static ESTADO_AJUSTE_PLAN_COMPENSACION_PENDIENTE = 'PENDIENTE';
  public static ESTADO_AJUSTE_PLAN_COMPENSACION_APROBADO = 'APROBADO';
  public static ESTADO_AJUSTE_PLAN_COMPENSACION_RECHAZADO = 'RECHAZADO';

  public static TIEMPO_FIN_CONTRATO = 'TFINCONTRATO';
  public static TIPO_VINCULACION_CONTRATISTA = 'CONTR';
  public static TIPO_VINCULACION_PROPIEDAD = 'PROP';
  public static TIPO_VINCULACION_TERCERO = 'TERC';
  

   // Incentivo bicicletas
  public static   DOMINIO_ESTADO_INCENTIVO_BICICLETA = 'EstadoIncentivoBicicleta';
	public static   ESTADO_INCENTIVO_BICI_APROBADO = 'APRO';
	public static   ESTADO_INCENTIVO_BICI_PENDIENTE = 'PEND';
	public static   ESTADO_INCENTIVO_BICI_COMPLETO = 'COMPL';
	public static   ESTADO_INCENTIVO_BICI_INCOMPLETO = 'INCOMP';

  //Estado bicicletas
  public static  DOMINIO_ESTADOS_BICICLETA = "EstadosBicicleta";
	public static  ESTADO_BICICLETA_RETIRADA= "BICIRETI";
	public static  ESTADO_BICICLETA_NO_INGRESO="BICINOIN";
	public static  ESTADO_BICICLETA_INGRESADA = "BICIIN";
  public static  ESTADO_BICICLETA_NO_SALIDA = "BICINOSAL";

  public static VALOR_ESTADO_BICICLETA_NO_INGRESO= "No registra ingreso";
  // Dominio estado turnos de compensaicones
  public static TURNO_COMPENSACION_ACTIVO = 'ACT';
  public static TURNO_COMPENSACION_INACTIVO = 'INA';


  //Dominio turno incentivo
  public static DOMINIO_TURNO_INCENTIVO = 'TurnoCompensacionBici';


  public static DOMINIO_ESTADO_VEHICULO = 'EstadoVehiculo';
  public static ESTADO_VEHICULO_ACTIVO = 'ACT';
  public static ESTADO_VEHICULO_INACTIVO = 'INA';

  // CONSTANTE TIEMPO DEL CONTADOR DE LA ATENCIÓN VENTANILLA
  public static PRM_TIEMPO_CONTADOR_VENTANILLA = 'TIEMPO_CONTADOR_VENTANILLA';
  public static PRM_TIEMPO_LLAMADO_AUTO_TURNO = 'TIEMPO_LLAMADO_AUTO_TURNO';


  public static TIPO_DOCUMENTO_CC = 'CC';


  // Dominio de genero
  public static GENERO_MASCULINO = 'MASC';
  public static GENERO_FEMENINO = 'FEME';

  // Dominio tipo vehiculo
  public static TIPO_VEHICULO = 'TipoVehiculo';

}
